import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import studentIcon from "../../../../../assets/images/student.png";
import nlLogo from "../../../../../assets/images/nl-images/NLSenaPage-image-on-topleft.png";
import "./subscription-helpers.m.css";

export const SubscriptionHelper = props => {
  const text = get(props.config, ["publisher", "publisher", "subscriptionHelperText"], "");
  const textTwo = get(props.config, ["publisher", "publisher", "helperTextSecond"], "");
  return (
    <div className="full-width-with-padding" styleName="sub-helper-wrapper">
      <div styleName="helper-boxes">
        <div styleName="col-1">
          <div styleName="image-wrapper">
            <img styleName src={assetify(studentIcon)} alt="newslaundry logo" />
          </div>
          <div styleName="content">
            <h3 styleName="heading">Student Subscription</h3>
            <p styleName="text">{text}</p>
            <div styleName="button-wrapper">
              <a href="/student-subscription-explained" styleName="button">Learn More</a>
            </div>
          </div>
        </div>
        <div styleName="col-1">
          <div styleName="image-wrapper">
            <img style={{width:"100px"}} src={assetify(nlLogo)} alt="NL sena" />

          </div>
          <div styleName="content">
            <h3 styleName="heading">NL Sena</h3>
            <p styleName="text">{textTwo}</p>
            <div styleName="button-wrapper">
              <a href="/sena" styleName="button">
                Join NL Sena
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubscriptionHelper.propTypes = {
  config: PropTypes.object
};
